

/**
 * 判斷瀏覽器的OS
 *
 * @author Benny
 * @version 1.0, 2016/10/25
 * @see
 * @since
 */
export class BrowserUtils {

    private static _constructor = (() => {
        // alert('ConvertUtils Static constructor');
    })();

    public static isAndroid(): boolean {
        let arys: RegExpMatchArray = navigator.userAgent.match(/Android/i);
        return arys !== null;
        // return navigator.userAgent.match(/Android/i);
    }

    public static isBlackBerry(): boolean {
        let arys: RegExpMatchArray = navigator.userAgent.match(/BlackBerry/i);
        return arys !== null;
    }
    public static isIOS(): boolean {
        let arys: RegExpMatchArray = navigator.userAgent.match(/iPhone|iPad|iPod/i);
        return arys !== null;
    }
    public static isOpera(): boolean {
        let arys: RegExpMatchArray = navigator.userAgent.match(/Opera Mini/i);
        return arys !== null;
    }
    public static isWindows(): boolean {
        let arys: RegExpMatchArray = navigator.userAgent.match(/IEMobile/i);
        return arys !== null;
    }
    public static isMobile(): boolean {
        return (this.isAndroid() || this.isBlackBerry() || this.isIOS() || this.isOpera() || this.isWindows());
    }
}
